import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/global-api-keys')({
  component: lazyRouteComponent(() => import('./-global-api-keys.lazy'), 'default'),
});
